import React from "react"; 
import './style.css'; 
import { HiOutlineViewList } from 'react-icons/hi'; 
let Login=(props)=> {
   return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div className="mai">
      <div className="main2">
        <input type="checkbox" id="chk1" aria-hidden="true" />
        <div className="signup1">
          <form>
            <label htmlFor="chk" aria-hidden="true" className="label1">Sign Up</label>
            <input type="Name" className="input1" name="name" placeholder="Name" required />
            <input type="email" className="input1" name="email" placeholder="Email" required />
            <input type="password" className="input1" name="pswd" placeholder="Password" required />
            <select id="selectMEF">
              <option value="0">Working As:</option>
              <option value="1">Combo</option>
              <option value="2">Sweper</option>
            </select>
            <button onClick={()=>props.history.push('/dashboard')} className="button1">Sign up</button>
          </form>
          <p onClick={()=>props.history.push('/signin')} className='newu'>Already Registered? Signup</p>
        </div>
      </div>
    </div>
  </div>) }
  
  export default Login;